import { palette } from '@client/theme/colors';
import { breakpoints, heights, theme } from '../constants';
import type { ThemeOptions } from '@mui/material';

const BottomNavigation: ThemeOptions['components'] = {
  MuiBottomNavigation: {
    styleOverrides: {
      root: {
        height: heights.BottomAppBar,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        borderTopColor: palette.divider,
        borderTopStyle: 'solid',
        borderTopWidth: 1,
        boxShadow: 'none',
        alignItems: 'center',
        zIndex: theme.zIndex.appBar + 3,

        [breakpoints.up('md')]: {
          display: 'none',
        },
      },
    },
  },
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: {
        '& svg': {
          fontSize: '24px',
          color: palette.text.disabled,
        },

        backgroundColor: 'transparent',
        color: palette.grey[500],

        '&.active svg': {
          color: palette.primary.main,
        },

        '&:hover svg': {
          color: palette.primary.light,
        },

        '&:focus svg, &:active svg': {
          color: palette.primary.main,
        },

        '&:disabled svg': {
          color: palette.grey[400],
        },

        '&.active > .MuiBottomNavigationAction-label': {
          color: palette.text.primary,
        },

        [theme.breakpoints.down('md')]: {
          maxWidth: theme.spacing(8),
        },
      },
      label: {
        fontSize: '10px !important',
        lineHeight: '10px',
        fontWeight: 600,
        color: palette.text.secondary,
        marginTop: theme.spacing(1 / 2),
        textAlign: 'center',
      },
    },
  },
};

export default BottomNavigation;
